<div class="campaign-editor-container">
  <!-- Header Section -->

  <div class="tab-container">
    <div class="header-container">
      <div class="header-section">
        <div class="header-content">
          <div class="back-button" (click)="navigateToCampaign()">
            <svg
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 7L14.5 7M1.5 7L7.5 13M1.5 7L7.5 1"
                stroke="#15172E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h1
            class="page-title"
            [matTooltip]="!isNewCampaign && campaignData.name ? campaignData.name : undefined"
            matTooltipPosition="above"
          >
            {{ isNewCampaign ? 'New Campaign' : campaignData.name || 'Edit Campaign' }}
          </h1>
        </div>
      </div>
      <!-- Tab Navigation - Responsive -->
      <!-- Vertical Tab for Desktop -->
      <app-vertical-tab
        *ngIf="!isMobileView"
        [tabs]="getFilteredTabs()"
        [activeTab]="activeTab"
        [sectionCompletionStatus]="sectionCompletionStatus"
        (tabChange)="onTabChange($event)"
        (subItemClick)="onSubItemClick($event.tabId, $event.subItem)"
      >
      </app-vertical-tab>

      <!-- Horizontal Tab for Mobile/Tablet -->
      <app-horizontal-tab
        *ngIf="isMobileView"
        [tabs]="getFilteredTabs()"
        [activeTab]="activeTab"
        [sectionCompletionStatus]="sectionCompletionStatus"
        (tabChange)="onTabChange($event)"
        (subItemClick)="onSubItemClick($event.tabId, $event.subItem)"
      >
      </app-horizontal-tab>
    </div>

    <!-- Tab Content Area -->
    <div class="tab-content">
      <div class="content-area">
        <div *ngIf="activeTab === 'overview'">
          <app-basic-info
            #basicInfoComponent
            [isExpanded]="basicInfoExpanded"
            [isCompleted]="isSectionCompleted('Basic Info')"
            [campaignData]="campaignData"
            (toggle)="onBasicInfoToggle($event)"
            (done)="onBasicInfoDone()"
            (dataChange)="updateCampaignData($event)"
          >
          </app-basic-info>
          <app-platform
            [isExpanded]="platformExpanded"
            [isCompleted]="isSectionCompleted('Platform')"
            [campaignData]="campaignData"
            (toggle)="onPlatformToggle($event)"
            (done)="onPlatformDone()"
            (dataChange)="updateCampaignData($event)"
          >
          </app-platform>
          <app-utm-tagging
            [isExpanded]="utmTaggingExpanded"
            [isCompleted]="isSectionCompleted('UTM tagging')"
            [campaignData]="campaignData"
            (toggle)="onUtmTaggingToggle($event)"
            (done)="onUtmTaggingDone()"
            (platformChange)="onUtmPlatformChange($event)"
          >
          </app-utm-tagging>
          <app-user-segment
            *ngIf="showUserSegmentSection"
            [isExpanded]="userSegmentExpanded"
            [isCompleted]="isSectionCompleted('User Segment')"
            [campaignData]="campaignData"
            (toggle)="onUserSegmentToggle($event)"
            (done)="onUserSegmentDone()"
            (dataChange)="updateCampaignData($event)"
          >
          </app-user-segment>
        </div>
        <div *ngIf="activeTab === 'offers'">
          <app-offer-overview
            [isExpanded]="offerOverviewExpanded"
            [isCompleted]="isSectionCompleted('Offer Overview')"
            [campaignData]="campaignData"
            [isSaving]="isOfferOverviewSaving"
            [promoCodeConflictMessage]="promoCodeConflictMessage"
            (toggle)="onOfferOverviewToggle($event)"
            (done)="onOfferOverviewDone()"
            (dataChange)="updateCampaignData($event)"
          >
          </app-offer-overview>
          <app-offer-details
            [isExpanded]="offerDetailsExpanded"
            [isCompleted]="isSectionCompleted('Offer Details')"
            [campaignData]="campaignData"
            [isSaving]="isOfferDetailsSaving"
            (toggle)="onOfferDetailsToggle($event)"
            (done)="onOfferDetailsDone()"
            (dataChange)="updateCampaignData($event)"
          >
          </app-offer-details>
          <app-usage-limits
            [isExpanded]="usageLimitsExpanded"
            [isCompleted]="isSectionCompleted('Usage Limits')"
            [campaignData]="campaignData"
            (toggle)="onUsageLimitsToggle($event)"
            (done)="onUsageLimitsDone()"
            (dataChange)="updateCampaignData($event)"
          >
          </app-usage-limits>
        </div>
        <div *ngIf="activeTab === 'content'">
          <!-- Email Component - Show only if email platform is selected -->
          <app-email
            *ngIf="isPlatformSelected('email')"
            [isExpanded]="emailExpanded"
            [isCompleted]="isSectionCompleted('Email')"
            [campaignData]="campaignData"
            (toggle)="onEmailToggle($event)"
            (done)="onEmailDone()"
            (dataChange)="onContentDataChange('email', $event)"
            (dataClear)="onContentDataClear('email')"
          >
          </app-email>

          <!-- Text Message Component - Show only if SMS platform is selected -->
          <app-text-message
            *ngIf="isPlatformSelected('sms')"
            [isExpanded]="textMessageExpanded"
            [isCompleted]="isSectionCompleted('Text Message')"
            [campaignData]="campaignData"
            (toggle)="onTextMessageToggle($event)"
            (done)="onTextMessageDone()"
            (dataChange)="onContentDataChange('sms', $event)"
            (mmsDataChange)="onContentDataChange('mms_campaign', $event)"
            (dataClear)="onContentDataClear('sms')"
            (mmsCampaignDataClear)="onContentDataClear('mms_campaign')"
          >
          </app-text-message>

          <!-- Facebook Component - Show only if Facebook platform is selected -->
          <app-facebook
            *ngIf="isPlatformSelected('facebook')"
            [isExpanded]="facebookExpanded"
            [isCompleted]="isSectionCompleted('Facebook')"
            [campaignData]="campaignData"
            (toggle)="onFacebookToggle($event)"
            (done)="onFacebookDone()"
            (dataChange)="onContentDataChange('facebook', $event)"
            (dataClear)="onContentDataClear('facebook')"
          >
          </app-facebook>

          <!-- Google Ads Component - Show only if Google Ads platform is selected -->
          <app-google-ads
            *ngIf="isPlatformSelected('google')"
            [isExpanded]="googleAdsExpanded"
            [isCompleted]="isSectionCompleted('Google Ads')"
            [campaignData]="campaignData"
            (toggle)="onGoogleAdsToggle($event)"
            (done)="onGoogleAdsDone()"
            (dataChange)="onContentDataChange('google', $event)"
            (dataClear)="onContentDataClear('google')"
          >
          </app-google-ads>
        </div>
        <div *ngIf="activeTab === 'advanced'">
          <app-optional-setting
            [campaignData]="campaignData"
            [currentCampaignId]="campaignId"
            [isCompleted]="isTabCompleted('advanced')"
            [activeSection]="optionalSettingsActiveSection"
            (done)="onOptionalSettingsDone()"
            (landingPageChange)="onContentDataChange('common_website', $event)"
            (landingPageClear)="onContentDataClear('common_website', 'landing_page')"
            (successPageChange)="onContentDataChange('common_website', $event)"
            (successPageClear)="onContentDataClear('common_website', 'success_page')"
            (deliveryChange)="onDeliveryChange($event)"
            (deliveryBatchChange)="onDeliveryBatchChange($event)"
            (deliveryEmailClear)="onDeliveryEmailClear()"
            (deliveryClear)="onDeliveryClear()"
            (navigateToSection)="onNavigateToTab($event)"
          >
          </app-optional-setting>
        </div>
        <div *ngIf="activeTab === 'finish'">
          <app-goals
            [isExpanded]="goalsExpanded"
            [isCompleted]="isSectionCompleted('Goals')"
            [campaignData]="campaignData"
            (toggle)="onGoalsToggle($event)"
            (done)="onGoalsDone()"
            (dataChange)="updateCampaignData($event)"
          >
          </app-goals>
          <app-schedule
            [isExpanded]="scheduleExpanded"
            [isCompleted]="isSectionCompleted('Schedule')"
            [campaignData]="campaignData"
            [isAllSectionsCompleted]="isAllSectionsCompleted()"
            (toggle)="onScheduleToggle($event)"
            (done)="onScheduleDone()"
            (dataChange)="updateCampaignData($event)"
            (openPreview)="onScheduleOpenPreview()"
          >
          </app-schedule>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-container">
    <div class="footer-content">
      <!-- Customer Selection Box -->

      <!-- Preview and Drafts Section -->
      <div class="preview-section">
        <button class="btn btn-tertiary btn-medium" (click)="onPreviewClick()">
          Preview
          <svg
            width="18"
            height="12"
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.33333 6C7.33333 6.44203 7.50893 6.86595 7.82149 7.17851C8.13405 7.49107 8.55797 7.66667 9 7.66667C9.44203 7.66667 9.86595 7.49107 10.1785 7.17851C10.4911 6.86595 10.6667 6.44203 10.6667 6C10.6667 5.55797 10.4911 5.13405 10.1785 4.82149C9.86595 4.50893 9.44203 4.33333 9 4.33333C8.55797 4.33333 8.13405 4.50893 7.82149 4.82149C7.50893 5.13405 7.33333 5.55797 7.33333 6Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.5 6C14.5 9.33333 12 11 9 11C6 11 3.5 9.33333 1.5 6C3.5 2.66667 6 1 9 1C12 1 14.5 2.66667 16.5 6Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div class="drafts-dropdown" *ngIf="!isAllSectionsCompleted()">
          <button
            class="drafts-btn"
            [disabled]="true"
            [matTooltip]="'Complete all sections for publishing campaign'"
            matTooltipPosition="below"
          >
            <span>Submit</span>
          </button>
        </div>
        <button
          class="btn btn-primary-green btn-medium"
          (click)="onPublishClick()"
          *ngIf="isAllSectionsCompleted()"
          [disabled]="isPublishing || !canPublish()"
          [matTooltip]="publishButtonTooltip"
          [matTooltipDisabled]="canPublish() && !isPublishing"
          matTooltipPosition="below"
        >
          <svg
            *ngIf="isPublishing"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="spinner"
          >
            <circle
              cx="8"
              cy="8"
              r="6"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-dasharray="31.416"
              stroke-dashoffset="31.416"
            >
              <animate
                attributeName="stroke-dasharray"
                dur="2s"
                values="0 31.416;15.708 15.708;0 31.416"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                dur="2s"
                values="0;-15.708;-31.416"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
          <span *ngIf="isPublishing">Publishing...</span>
          <span *ngIf="!isPublishing">Publish</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Campaign Preview Modal -->
  <app-campaign-preview-modal
    [isOpen]="showPreviewModal"
    [campaignData]="campaignData"
    [sectionCompletionStatus]="sectionCompletionStatus"
    [segmentsList]="segmentsList"
    [locationsList]="locationsList"
    [isPublishing]="isPublishing"
    (close)="onClosePreviewModal()"
    (confirmAndPublish)="onConfirmAndPublish()"
    (navigateToTab)="onNavigateToTab($event)"
  >
  </app-campaign-preview-modal>

  <app-campaign-success-modal
    [isOpen]="showSuccessModal"
    [campaignId]="campaignId"
    [campaignData]="campaignData"
    (close)="onCloseCampaignSuccessModal()"
  >
  </app-campaign-success-modal>
</div>
